"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerModule = void 0;
const getContainerModuleId_1 = require("../actions/getContainerModuleId");
class ContainerModule {
    #id;
    #load;
    constructor(load) {
        this.#id = (0, getContainerModuleId_1.getContainerModuleId)();
        this.#load = load;
    }
    get id() {
        return this.#id;
    }
    load(options) {
        return this.#load(options);
    }
}
exports.ContainerModule = ContainerModule;
//# sourceMappingURL=ContainerModule.js.map